import { NavigationContext } from '@wix/gg-components/orchestrator';
import { BI_CONSTANTS } from '../hooks/biLogger/biConstants';
import { biLogger } from '../hooks';

export const storeNameNextAction = async (context: NavigationContext) => {
  biLogger.actionClicked({
    action: BI_CONSTANTS.ACTION.STORE_NAME_PAGE_NEXT,
    button_name: BI_CONSTANTS.BUTTON_NAME.NEXT,
  });
};

